<div class="sliderContainer" [style.height]="bannerHeight" [style.width]="bannerWidth"
  *ngIf="this.transitionTime && sliderArray.length > 0" [class.forEdit]="forEdit">
  <div class="img-container ga-billboard" *ngFor="let i of sliderArray; let select = index;"
    [style.height]="bannerHeight" [style.width]="bannerWidth" [class.clickable]="i.link && i.link !== ''"
    [ngClass]="{'selected': select == selectedIndex}" (click)="selectBanner($event, i.type, i.link)">
    <img src="{{i.url}}" alt="{{bannerName}}" [attr.data-link]="i.link">
  </div>
</div>